'use strict';

var _ = require('lodash');
var FlightProfileChartAggregationFactory = function FlightProfileChartAggregationFactory(DataAggregationFactory) {
  var AVAILABLE_CURVES_CONFIGS = [{
    curveName: 'bookingCurveCurrentYear',
    metric: 'booking',
    isStringType: false,
    cutOffToDtd: true
  }, {
    curveName: 'bookingCurveLastYear',
    metric: 'booking',
    isStringType: false,
    cutOffToDtd: false
  }, {
    curveName: 'bookingCurveReference',
    metric: 'booking',
    isStringType: false,
    cutOffToDtd: false
  }, {
    curveName: 'bookingCurveSeasonalAverage',
    metric: 'booking',
    isStringType: false
  }, {
    curveName: 'capacityCurveCurrentYear',
    metric: 'capacity',
    isStringType: false,
    cutOffToDtd: true
  }, {
    curveName: 'capacityCurveLastYear',
    metric: 'capacity',
    isStringType: false,
    cutOffToDtd: false
  }, {
    curveName: 'capacityCurveReference',
    metric: 'capacity',
    isStringType: false,
    cutOffToDtd: false
  }, {
    curveName: 'revenueCurveCurrentYear',
    metric: 'revenue',
    isStringType: false,
    cutOffToDtd: true
  }, {
    curveName: 'revenueCurveLastYear',
    metric: 'revenue',
    isStringType: false,
    cutOffToDtd: false
  }, {
    curveName: 'revenueCurveSeasonalAverage',
    metric: 'revenue',
    isStringType: false
  }, {
    curveName: 'loadFactorCurveCurrentYear',
    metric: 'loadFactor',
    isStringType: false,
    cutOffToDtd: true
  }, {
    curveName: 'loadFactorCurveLastYear',
    metric: 'loadFactor',
    isStringType: false,
    cutOffToDtd: false
  }, {
    curveName: 'loadFactorCurveReference',
    metric: 'loadFactor',
    isStringType: false,
    cutOffToDtd: false
  }, {
    curveName: 'loadFactorCurveSeasonalAverage',
    metric: 'loadFactor',
    isStringType: false,
    cutOffToDtd: false
  }, {
    curveName: 'minURDBookingCurve',
    metric: 'booking',
    isStringType: false,
    cutOffToDtd: false
  }, {
    curveName: 'maxURDBookingCurve',
    metric: 'booking',
    isStringType: false,
    cutOffToDtd: false
  }, {
    curveName: 'avgURDBookingCurve',
    metric: 'booking',
    isStringType: false,
    cutOffToDtd: false
  }, {
    curveName: 'minURDRevenueCurve',
    metric: 'revenue',
    isStringType: false,
    cutOffToDtd: false
  }, {
    curveName: 'maxURDRevenueCurve',
    metric: 'revenue',
    isStringType: false,
    cutOffToDtd: false
  }, {
    curveName: 'avgURDRevenueCurve',
    metric: 'revenue',
    isStringType: false,
    cutOffToDtd: false
  }, {
    curveName: 'minURDLoadFactorCurve',
    metric: 'loadFactor',
    isStringType: false,
    cutOffToDtd: false
  }, {
    curveName: 'maxURDLoadFactorCurve',
    metric: 'loadFactor',
    isStringType: false,
    cutOffToDtd: false
  }, {
    curveName: 'avgURDLoadFactorCurve',
    metric: 'loadFactor',
    isStringType: false,
    cutOffToDtd: false
  }, {
    curveName: 'lcaEffAvailCurveCurrentYear',
    metric: 'lcaEffAvail',
    isStringType: false,
    cutOffToDtd: false
  }, {
    curveName: 'lcaEffAvailCurveLastYear',
    metric: 'lcaEffAvail',
    isStringType: false,
    cutOffToDtd: false
  }, {
    curveName: 'lowestClassAvailableCurveCurrentYear',
    metric: 'lowestClassAvailable',
    isStringType: true,
    cutOffToDtd: false
  }, {
    curveName: 'lowestClassAvailableCurveLastYear',
    metric: 'lowestClassAvailable',
    isStringType: true,
    cutOffToDtd: false
  }];
  function FlightProfileChartAggregation() {
    DataAggregationFactory.call(this, 'flight-cabin-profile-mode', 'flight-profile-chart');
  }
  function cutOffToDtd(dtd, curveData) {
    return _.filter(curveData, function (el) {
      return el.dtd >= dtd;
    });
  }
  FlightProfileChartAggregation.prototype = Object.create(DataAggregationFactory.prototype);
  FlightProfileChartAggregation.constructor = FlightProfileChartAggregation;
  FlightProfileChartAggregation.prototype.canAggregate = function (sourceType, targetType) {
    return this.targetType === targetType && this.sourceType === sourceType;
  };
  FlightProfileChartAggregation.prototype.aggregate = function (rawData, metricKeys, metricDescriptor) {
    var legCabin = metricDescriptor.params.legCabin;
    var that = this;
    return _.reduce(AVAILABLE_CURVES_CONFIGS, function (result, curveConfig) {
      var mergedCurveData = that.mergeCurveData(rawData, curveConfig);
      if (curveConfig.cutOffToDtd) {
        mergedCurveData = cutOffToDtd(legCabin.daysToDeparture, mergedCurveData);
      }
      result[curveConfig.curveName] = mergedCurveData;
      return result;
    }, {});
  };
  return FlightProfileChartAggregation;
};
FlightProfileChartAggregationFactory.$inject = ['DataAggregationFactory'];
module.exports = FlightProfileChartAggregationFactory;